module.exports = __webpack_public_path__ + "img/smlogo.9cb87d4a.png";